import { render, staticRenderFns } from "./expire.vue?vue&type=template&id=0ab4e816&"
import script from "./expire.vue?vue&type=script&lang=js&"
export * from "./expire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports